module.exports = __webpack_public_path__ + "poster11.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster11.png
// module id = 1141
// module chunks = 10